/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SettingDefs from './defs.defs.js'

const $nsid = 'tools.ozone.setting.listOptions'

export { $nsid }

/** List settings with optional filtering */
const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    scope: l.optional(
      l.withDefault(
        l.string<{ knownValues: ['instance', 'personal'] }>(),
        'instance',
      ),
    ),
    prefix: l.optional(l.string()),
    keys: l.optional(l.array(l.string({ format: 'nsid' }), { maxLength: 100 })),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    options: l.array(
      l.ref<SettingDefs.Option>((() => SettingDefs.option) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
